import DefaultLayout from '../../../layout/DefautlLayout';
import Header from '../../../components/header/Header';

import { Link } from 'react-router-dom';
import TreatmentIntroBanner from '../../../components/treatmentBanner/treatmentBanner';

const NonSurgicalRhinoplastyPage = () => {
	const prices = [{ label: 'Treatment', value: 'From €375/£255' }];

	return (
		<DefaultLayout>
			<Header />
			<div id="Content">
				<div className="content_wrapper clearfix">
					<div className="sections_group">
						<div className="extra_content">
							<TreatmentIntroBanner
								title="Non-Surgical Rhinoplasty"
								description="Non-surgical rhinoplasty uses dermal filler to subtly reshape the nose, correct bumps or asymmetry, and enhance definition—all without surgery, in just 30-45 minutes."
								quote=" Immediate results, no surgery, minimal downtime. "
								backgroundImage="/assets/images/banners/treatment-xl-2.png"
							/>

							<div className="section mcb-section" id="image" style={{ paddingBottom: '70px' }}>
								<div className="section_wrapper mcb-section-inner">
									<div className="wrap mcb-wrap one valign-top clearfix">
										<div className="mcb-wrap-inner">
											<div className="column mcb-column one-third column_image">
												<div className="image_frame image_item scale-with-grid aligncenter has_border hrmargin_b_30">
													<div className="image_wrapper">
														<div className="mask"></div>
														<img
															className="scale-with-grid"
															src="/assets/images/treatments/non-surgical-rhinoplasty.jpg"
															alt="home_betheme_blog_masonry_1"
															width="960"
															height="960"
														/>
													</div>
												</div>
											</div>
											<div className="column mcb-column two-third column_column">
												<div className="column_attr clearfix">
													<h4>What to Expect from Non-Surgical Rhinoplasty</h4>
													<ul>
														<li>The treatment takes around 30 to 45 minutes to complete.</li>
														<li>
															Initial results are visible immediately, with full effects becoming noticeable within 1 to 2 weeks.
														</li>
														<li>
															Results typically last between 12 to 18 months, depending on the type of filler used and the
															individual's metabolism.
														</li>
														<li>There is minimal downtime, usually no more than 24 hours.</li>
														<li>
															This procedure helps smooth out bumps and correct minor asymmetries of the nose without surgery.
														</li>
														<li>
															It enhances the definition of the nasal bridge and tip, creating a more balanced and refined
															profile.
														</li>
														<li>A non-invasive, reversible option that offers an alternative to traditional rhinoplasty.</li>
														<li>
															Ideal for those who want to subtly reshape their nose—such as lifting the nasal tip or reducing a
															dorsal hump—without undergoing surgery.
														</li>
													</ul>

													<h4>Possible Side Effects</h4>
													<ul>
														<li>Temporary swelling, redness, bruising, tenderness, or itching (usually 2-7 days)</li>
														<li>Cold sore flare-ups in individuals prone to them</li>
														<li>
															Rare but serious risk of vascular compromise - treatment should always be performed by a qualified
															and experienced injector
														</li>
													</ul>
												</div>
											</div>

											<div className="column mcb-column one column_column">
												<div className="column_attr clearfix">
													<div className="column one column_pricing_item">
														<div className="pricing-box custom-pricing-box pricing-box-table pricing-box-featured">
															<div className="plan-header">
																<h3>Pricing</h3>
															</div>
															<div className="plan-inside clearfix">
																<hr className="bg-theme" />
																<ul>
																	{prices.map(({ label, value }, idx) => (
																		<li key={idx} className="clearfix" style={{ paddingLeft: '5%', paddingRight: '5%' }}>
																			<div>
																				<strong>{label}</strong>
																			</div>
																			<div style={{ whiteSpace: 'pre-line' }}>{value}</div>
																		</li>
																	))}
																</ul>
																<hr className="bg-theme" />
															</div>

															<div className="plan-footer">
																<Link to="/book-now" className="button button_left button_theme button_js">
																	<span className="button_icon">
																		<i className="icon-basket"></i>
																	</span>
																	<span className="button_label">BOOK NOW</span>
																</Link>
															</div>
														</div>
													</div>
												</div>
											</div>

											<div className="column mcb-column one column_divider">
												<hr className="no_line" />
											</div>

											<div className="column one column_slider">
												<div className="column_attr clearfix hrmargin_b_60">
													<h2
														className="hrmargin_b_60"
														style={{
															textAlign: 'center',
														}}>
														Results
													</h2>

													<div className="content_slider">
														<ul className="content_slider_ul">
															<li className="content_slider_li_1">
																<img
																	width="100%"
																	height="auto"
																	src="/assets/images/treatments/non-surgical-rhinoplasty-result.jpg"
																	alt="Non-Surgical Rhinoplasty result"
																	className="scale-with-grid wp-post-image"
																/>
															</li>
															{/* Add more slides as needed */}
														</ul>
													</div>
												</div>
											</div>

											<div className="column mcb-column one column_divider">
												<hr className="no_line" />
											</div>

											<div className="column mcb-column one column_column">
												<div className="column_attr clearfix">
													<h2
														className="hrmargin_b_60"
														style={{
															textAlign: 'center',
														}}>
														After-Care
													</h2>
													<ul>
														<li>
															Do not touch, rub, or apply makeup to the treated area for at least 4-6 hours to avoid infection and
															product movement.
														</li>
														<li>Apply a cold compress gently to reduce swelling or bruising. Avoid applying pressure.</li>
														<li>Avoid strenuous exercise, saunas, steam rooms, and hot showers for 24-48 hours post-treatment.</li>
														<li>Sleep with your head elevated the first night to help minimize swelling.</li>
														<li>
															Avoid wearing glasses or sunglasses that rest on the bridge of your nose for at least 48 hours after
															treatment.
														</li>
														<li>
															Refrain from alcohol consumption and taking anti-inflammatory medications (unless prescribed) for 24
															hours to reduce bruising risk.
														</li>
														<li>
															Use only gentle skincare products for a few days; avoid acids, retinoids, and exfoliants on the
															treated area.
														</li>
														<li>
															Contact your provider if you notice unusual pain, blanching, or discolouration in the area—this may
															indicate a vascular issue.
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</DefaultLayout>
	);
};

export default NonSurgicalRhinoplastyPage;
